import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import subtractMonths from 'date-fns/sub_months';

// Components
import { ANALYTICS_DETAIL } from 'constants/detalization';
import { DatePicker } from 'components';
import { pushDetalizationAnalytics } from 'utils/analytics/detalization';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * @param isModal - булевый параметр, подставляет стили для модельного окна этого компонента
 * @param endPeriod - конец периода
 * @param startPeriod - начало периода
 * @param activeOption - текущий выбранный период
 * @param setEndPeriod - - action изменения конца периода
 * @param setStartPeriod - action изменения начала периода
 */

const DatesPicker = ({
  isModal,
  endPeriod,
  startPeriod,
  activeOption,
  setEndPeriod,
  setStartPeriod,
}) => {
  const date = new Date();

  useEffect(() => {
    if (activeOption.slug === 'choose-period') {
      pushDetalizationAnalytics(ANALYTICS_DETAIL.PERIOD_CHOOSE,
        {
          period: activeOption.slug,
          period_new: `${startPeriod}-${endPeriod}`,
        });
    }
  }, [activeOption, startPeriod, endPeriod]);

  return (
    <div className={cx('dates', { 'dates--modal': isModal })}>
      <div className={cx('date-group')}>
        <DatePicker
          className={cx('date-picker')}
          value={startPeriod}
          min={subtractMonths(date, 6)}
          max={endPeriod}
          onChange={setStartPeriod}
        />
      </div>
      <span className={cx('date-label')} />
      <div className={cx('date-group')}>
        <DatePicker
          className={cx('date-picker')}
          value={endPeriod}
          min={startPeriod}
          max={date}
          onChange={setEndPeriod}
        />
      </div>
    </div>
  );
};

DatesPicker.propTypes = {
  setStartPeriod: PropTypes.func,
  setEndPeriod: PropTypes.func,
  activeOption: PropTypes.shape({
    slug: PropTypes.string,
    label: PropTypes.string,
  }),
  startPeriod: PropTypes.string,
  endPeriod: PropTypes.string,
  isModal: PropTypes.bool,
};

export { DatesPicker };
